module.exports = "/fonts/vendor/@fontsource/inter/files/inter-all-400-normal.woff?fe5d253c64831f746cc88b6df016884f";